import { gql } from "@grandvisionhq/graphql";
const availableStoreNearbyProperties = gql`
  fragment AvailableStoreNearbyProperties on Store {
    code
    globalStoreId
    name
    shortName
    streetName
    streetNumber
    postalCode
    town
    province
    country
    lat
    lon
    phone
    distance
    accessibility
    hearingAppointmentPossible
    globalStoreId
  }
`;
const GET_AVAILABILITY_STORES_NEARBY = gql`
  query GetAvailabilityStoresNearby(
    $appointmentTypeId: ID!
    $longitude: Longitude!
    $latitude: Latitude!
    $startDate: Date!
    $endDate: Date
    $startTime: String
    $endTime: String
  ) {
    availabilityStoresNearby(
      appointmentTypeId: $appointmentTypeId
      longitude: $longitude
      latitude: $latitude
      startDate: $startDate
      endDate: $endDate
      startTime: $startTime
      endTime: $endTime
    ) {
      availability {
        storeCode
        slotsAvailable
        nextAvailableBookingDate
        store {
          ...AvailableStoreNearbyProperties
        }
      }
      failures {
        ... on AppointmentFailure {
          message
          __typename
        }
      }
    }
  }
  ${availableStoreNearbyProperties}
`;
export {
  GET_AVAILABILITY_STORES_NEARBY
};
//# sourceMappingURL=get-availability-stores-nearby.js.map
